import { SeatReclineExtraIcon } from './SeatReclineExtraIcon';

/**
 * author: Google
 * id EB83D5D9-0439-476C-9BFD-04B5D6789940
 * name seat-recline-extra
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-recline-extra.svg
 * tags
 */
export const AirlineSeatReclineExtraIcon = SeatReclineExtraIcon;
export default AirlineSeatReclineExtraIcon